export const environment = {
    production: false,
    // Base del backend GEOLIFTEC (core). Todos los endpoints cuelgan de /api/v1.
    api: 'https://staging.yorisapp.com/api/v1',
    appName: 'GEOLIFTEC (Dev)',
    // Flag GLOBAL para los features que aún no tienen backend (turnos, inspecciones,
    // calificaciones, tiempo real, informes, tendencias): true = repositorios mock.
    // Auth y navegación NO miran este flag: van siempre contra el backend real.
    useMock: true,
    // Flag DEDICADO del Tablero Principal: true = datos ficticios (mientras no haya
    // datos reales registrados); false = consume el backend real (`/dashboard/*` + SSE).
    mockDashboard: true,
}
